import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { PrivateLayoutComponent } from '../../ui'
import { GlobalAlert } from '../components'
import { usePrivateRoutes } from './router.hook'

export const PrivateRouter = () => {
  const { getPrivateRoutes } = usePrivateRoutes()
  const router = getPrivateRoutes()

  return (
    <PrivateLayoutComponent>
      <GlobalAlert />
      <Routes>
        {router.routes.map((r) => (
          <Route key={r.path} path={r.path + '/*'} element={<r.component />} />
        ))}
        <Route path="*" element={<Navigate to={router.redirect} replace />} />
      </Routes>
    </PrivateLayoutComponent>
  )
}
